import * as React from 'react';
import classnames from 'classnames';

import './notification-dot.scss';

type Props = {
  bordered?: boolean
};

const NotificationDot = (
  {
    bordered
  }: Props
): JSX.Element => {
  const classes = classnames('notification-dot', {
    'notification-dot--bordered': bordered
  });

  return (
    <div className={classes} />
  );
};

export default NotificationDot;
